var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c("ReprogramarCronograma"),
      _vm._v(" "),
      _c("SolicitarEjecucionVacacion"),
      _vm._v(" "),
      _c("VerDetalle"),
      _vm._v(" "),
      _c("VerDetalleUsoVacacion"),
      _vm._v(" "),
      _c("AprobarUsoJefeInmediato"),
      _vm._v(" "),
      _c("AprobarReprogramacionVacacion"),
      _vm._v(" "),
      _c("Reprogramar"),
      _vm._v(" "),
      _c("SolicitarEjecucionVacacion"),
      _vm._v(" "),
      _c("VerReporte"),
      _vm._v(" "),
      _c("VerReprogramaciones"),
      _vm._v(" "),
      _c("RechazarReprogramacionJefe"),
      _vm._v(" "),
      _c("VerPermiso"),
      _vm._v(" "),
      _c("AprobarPermiso"),
      _vm._v(" "),
      _c("RechazarPermiso"),
      _vm._v(" "),
      _c(
        "h3",
        { staticClass: "primary--text" },
        [
          _c("v-icon", { attrs: { color: "primary" } }, [_vm._v("done")]),
          _vm._v(" Aprobación/Rechazo de vacaciones (Jefe)\n  ")
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-flex",
        { attrs: { xs12: "", md6: "" } },
        [
          _c("v-autocomplete", {
            attrs: {
              items: _vm.lista_gestiones,
              "item-text": "periodo",
              "item-value": "periodo",
              label: "Seleccione la gestión",
              required: "",
              outline: "",
              success: "",
              clearable: ""
            },
            on: {
              change: function($event) {
                return _vm.actualizaCrudTable()
              }
            },
            model: {
              value: _vm.periodo_seleccionado,
              callback: function($$v) {
                _vm.periodo_seleccionado = $$v
              },
              expression: "periodo_seleccionado"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card",
        [
          _c(
            "v-card-text",
            [
              _c("p", [
                _c("strong", [_vm._v("Dependencia: ")]),
                _vm._v(
                  _vm._s(this.$storage.get("user").unidad[0].nombre_unidad) +
                    "\n      "
                )
              ]),
              _vm._v(" "),
              _c(
                "v-layout",
                {
                  attrs: {
                    "align-center": "",
                    "justify-start": "",
                    row: "",
                    wrap: ""
                  }
                },
                [
                  _c(
                    "v-flex",
                    { attrs: { shrink: "" } },
                    [
                      _c(
                        "v-tooltip",
                        { attrs: { bottom: "" } },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "btn-refresh",
                              attrs: { slot: "activator" },
                              nativeOn: {
                                click: function($event) {
                                  return function() {
                                    _vm.filterShow = _vm.filterShow
                                      ? false
                                      : true
                                  }.apply(null, arguments)
                                }
                              },
                              slot: "activator"
                            },
                            [_c("v-icon", [_vm._v("filter_list")])],
                            1
                          ),
                          _vm._v(" "),
                          _c("span", [_vm._v("Búsqueda/filtros")])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { "d-flex": "", shrink: "" } },
                    [
                      _c(
                        "v-tooltip",
                        { attrs: { bottom: "" } },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "btn-refresh",
                              attrs: { slot: "activator" },
                              nativeOn: {
                                click: function($event) {
                                  return _vm.cargarVacacionesProgramadas(
                                    _vm.periodo_seleccionado
                                  )
                                }
                              },
                              slot: "activator"
                            },
                            [_c("v-icon", [_vm._v("refresh")])],
                            1
                          ),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("common.updateList")))
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { "d-flex": "", shrink: "" } },
                    [_c("CalendarioVacaciones")],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { xs12: "" } },
                [
                  _c("transition", { attrs: { name: "slide-fade" } }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.filterShow,
                            expression: "filterShow"
                          }
                        ],
                        staticClass: "filter-container-rrhh"
                      },
                      [
                        _c(
                          "v-icon",
                          { attrs: { small: "", color: "primary" } },
                          [_vm._v("search")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "filter-item" },
                          [
                            _c("v-text-field", {
                              attrs: { label: "Nro", type: "number" },
                              on: { input: _vm.filterNumero },
                              model: {
                                value: _vm.form.numero,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "numero", $$v)
                                },
                                expression: "form.numero"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "filter-item" },
                          [
                            _c("v-text-field", {
                              attrs: { label: "Nombres", type: "text" },
                              on: { input: _vm.filterNombres },
                              model: {
                                value: _vm.form.nombres,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "nombres", $$v)
                                },
                                expression: "form.nombres"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "filter-item" },
                          [
                            _c("v-text-field", {
                              attrs: { label: "Fecha salida", type: "text" },
                              on: { input: _vm.filterFechaDesde },
                              model: {
                                value: _vm.form.fecha_desde,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "fecha_desde", $$v)
                                },
                                expression: "form.fecha_desde"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "filter-item" },
                          [
                            _c("v-text-field", {
                              attrs: { label: "Fecha fin", type: "text" },
                              on: { input: _vm.filterFechaHasta },
                              model: {
                                value: _vm.form.fecha_hasta,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "fecha_hasta", $$v)
                                },
                                expression: "form.fecha_hasta"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "filter-item" },
                          [
                            _c("v-text-field", {
                              attrs: {
                                label: "Días programados",
                                type: "number"
                              },
                              on: { input: _vm.filterDias },
                              model: {
                                value: _vm.form.dias,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "dias", $$v)
                                },
                                expression: "form.dias"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "filter-item" },
                          [
                            _c("v-text-field", {
                              attrs: { label: "Tipo", type: "text" },
                              on: { input: _vm.filterTipo },
                              model: {
                                value: _vm.form.tipo,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "tipo", $$v)
                                },
                                expression: "form.tipo"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "filter-item" },
                          [
                            _c("v-text-field", {
                              attrs: { label: "Estado" },
                              on: { input: _vm.filterEstado },
                              model: {
                                value: _vm.form.estado,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "estado", $$v)
                                },
                                expression: "form.estado"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "filter-item" },
                          [
                            _c("v-text-field", {
                              attrs: { label: "Fecha solicitud" },
                              on: { input: _vm.filterFechaSolicitud },
                              model: {
                                value: _vm.form.fecha_solicitud,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "fecha_solicitud", $$v)
                                },
                                expression: "form.fecha_solicitud"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "btn-filter" },
                          [
                            _c(
                              "v-tooltip",
                              { attrs: { bottom: "" } },
                              [
                                _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      slot: "activator",
                                      icon: "",
                                      small: ""
                                    },
                                    nativeOn: {
                                      click: function($event) {
                                        return _vm.recargar()
                                      }
                                    },
                                    slot: "activator"
                                  },
                                  [
                                    _c("v-icon", { attrs: { small: "" } }, [
                                      _vm._v("refresh")
                                    ])
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("span", [_vm._v("Recargar filtros")])
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-tooltip",
                              { attrs: { bottom: "" } },
                              [
                                _c(
                                  "v-btn",
                                  {
                                    attrs: { slot: "activator", icon: "" },
                                    nativeOn: {
                                      click: function($event) {
                                        return function() {
                                          _vm.filterShow = false
                                        }.apply(null, arguments)
                                      }
                                    },
                                    slot: "activator"
                                  },
                                  [
                                    _c("v-icon", { attrs: { small: "" } }, [
                                      _vm._v("close")
                                    ])
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("span", [_vm._v("Cerrar filtros")])
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _vm.sw_crud_table
                ? _c(
                    "v-data-table",
                    {
                      staticClass: "elevation-1 tabla-comprimida-light",
                      attrs: {
                        items: _vm.lista_vacaciones,
                        headers: _vm.headers,
                        "disable-initial-sort": true,
                        "item-key": "id",
                        loading: _vm.loading,
                        "no-data-text": "No se tiene registros",
                        "no-results-text": "No se encontraron coincidencias",
                        search: _vm.filters,
                        "custom-filter": _vm.customFilter
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "items",
                            fn: function(items) {
                              return [
                                _c(
                                  "td",
                                  {
                                    staticClass: "text-xs-center",
                                    attrs: {
                                      id:
                                        items.item.tipo == "P"
                                          ? "celdaP"
                                          : items.item.tipo == "R"
                                          ? "celdaR"
                                          : items.item.tipo == "VC"
                                          ? "celdaVC"
                                          : "celdaFR"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(items.item.numero) +
                                        "\n          "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  {
                                    staticClass: "text-xs-center",
                                    attrs: {
                                      id:
                                        items.item.tipo == "P"
                                          ? "celdaP"
                                          : items.item.tipo == "R"
                                          ? "celdaR"
                                          : items.item.tipo == "VC"
                                          ? "celdaVC"
                                          : "celdaFR"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(items.item.nombres) +
                                        "\n          "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  {
                                    staticClass: "text-xs-center",
                                    attrs: {
                                      id:
                                        items.item.tipo == "P"
                                          ? "celdaP"
                                          : items.item.tipo == "R"
                                          ? "celdaR"
                                          : items.item.tipo == "VC"
                                          ? "celdaVC"
                                          : "celdaFR"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(items.item.fecha_desde) +
                                        "\n          "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  {
                                    staticClass: "text-xs-center",
                                    attrs: {
                                      id:
                                        items.item.tipo == "P"
                                          ? "celdaP"
                                          : items.item.tipo == "R"
                                          ? "celdaR"
                                          : items.item.tipo == "VC"
                                          ? "celdaVC"
                                          : "celdaFR"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(items.item.fecha_hasta) +
                                        "\n          "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  {
                                    staticClass: "text-xs-center",
                                    attrs: {
                                      id:
                                        items.item.tipo == "P"
                                          ? "celdaP"
                                          : items.item.tipo == "R"
                                          ? "celdaR"
                                          : items.item.tipo == "VC"
                                          ? "celdaVC"
                                          : "celdaFR"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(items.item.dias) +
                                        "\n          "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  {
                                    staticClass: "text-xs-center",
                                    attrs: {
                                      id:
                                        items.item.tipo == "P"
                                          ? "celdaP"
                                          : items.item.tipo == "R"
                                          ? "celdaR"
                                          : items.item.tipo == "VC"
                                          ? "celdaVC"
                                          : "celdaFR"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(items.item.tipo) +
                                        "\n          "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  {
                                    staticClass: "text-xs-center",
                                    attrs: {
                                      id:
                                        items.item.tipo == "P"
                                          ? "celdaP"
                                          : items.item.tipo == "R"
                                          ? "celdaR"
                                          : items.item.tipo == "VC"
                                          ? "celdaVC"
                                          : "celdaFR"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(
                                          items.item.estado &&
                                            items.item.id_estado == 7
                                            ? "Aprobada Inmediato Superior"
                                            : items.item.estado
                                            ? items.item.estado
                                            : ""
                                        ) +
                                        "\n          "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  {
                                    staticClass: "text-xs-center",
                                    attrs: {
                                      id:
                                        items.item.tipo == "P"
                                          ? "celdaP"
                                          : items.item.tipo == "R"
                                          ? "celdaR"
                                          : items.item.tipo == "VC"
                                          ? "celdaVC"
                                          : "celdaFR"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(
                                          items.item.jefe &&
                                            (items.item.id_estado == 55 ||
                                              items.item.id_estado == 58 ||
                                              items.item.id_estado == 68 ||
                                              items.item.id_estado == 69)
                                        ) +
                                        "\n          "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  {
                                    staticClass: "text-xs-center",
                                    attrs: {
                                      id:
                                        items.item.tipo == "P"
                                          ? "celdaP"
                                          : items.item.tipo == "R"
                                          ? "celdaR"
                                          : items.item.tipo == "VC"
                                          ? "celdaVC"
                                          : "celdaFR"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(items.item.fecha_solicitud) +
                                        "\n          "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  {
                                    staticClass: "text-xs-center",
                                    attrs: {
                                      id:
                                        items.item.tipo == "P"
                                          ? "celdaP"
                                          : items.item.tipo == "R"
                                          ? "celdaR"
                                          : items.item.tipo == "VC"
                                          ? "celdaVC"
                                          : "celdaFR"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(
                                          items.item.justificacion_rechazo
                                        ) +
                                        "\n          "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                items.item.tipo == "P" ||
                                items.item.tipo == "R" ||
                                items.item.tipo == "FR"
                                  ? _c(
                                      "td",
                                      {
                                        attrs: {
                                          id:
                                            items.item.tipo == "P"
                                              ? "celdaP"
                                              : items.item.tipo == "R"
                                              ? "celdaR"
                                              : items.item.tipo == "VC"
                                              ? "celdaVC"
                                              : "celdaFR"
                                        }
                                      },
                                      [
                                        _c(
                                          "v-btn",
                                          {
                                            attrs: {
                                              color: "#3dca24",
                                              icon: "",
                                              title: "Ver detalle"
                                            },
                                            on: {
                                              click: function($event) {
                                                $event.preventDefault()
                                                return _vm.verDetalle(
                                                  items.item
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _c("v-icon", [
                                              _vm._v("remove_red_eye")
                                            ])
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        items.item.id_estado == "55" &&
                                        items.item.id_jefe ==
                                          items.item.id_jefe_ultimo &&
                                        _vm.bandera_fecha_corte
                                          ? _c(
                                              "v-btn",
                                              {
                                                attrs: {
                                                  color: "#44deaa",
                                                  icon: "",
                                                  title:
                                                    "Aprobar uso de vacación"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    $event.preventDefault()
                                                    return _vm.aprobarUsoJefeInmediato(
                                                      items.item
                                                    )
                                                  }
                                                }
                                              },
                                              [_c("v-icon", [_vm._v("send")])],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        items.item.id_estado == "55" &&
                                        items.item.tipo == "P" &&
                                        !items.item.id_padre &&
                                        _vm.bandera_fecha_corte
                                          ? _c(
                                              "v-btn",
                                              {
                                                attrs: {
                                                  color: "#FF5D34",
                                                  icon: "",
                                                  title: "Reprogramar"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    $event.preventDefault()
                                                    return _vm.reprogramar(
                                                      items.item
                                                    )
                                                  }
                                                }
                                              },
                                              [_c("v-icon", [_vm._v("close")])],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        items.item.id_estado_hijo == "68" &&
                                        _vm.bandera_fecha_corte
                                          ? _c(
                                              "v-btn",
                                              {
                                                attrs: {
                                                  color: "#a87af3",
                                                  icon: "",
                                                  title:
                                                    "Aprobar reprogramación de vacación"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    $event.preventDefault()
                                                    return _vm.aprobarReprogramacion(
                                                      items.item
                                                    )
                                                  }
                                                }
                                              },
                                              [_c("v-icon", [_vm._v("send")])],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        items.item.id_estado_hijo &&
                                        items.item.id_estado_hijo == 68 &&
                                        _vm.bandera_fecha_corte
                                          ? _c(
                                              "v-btn",
                                              {
                                                attrs: {
                                                  color: "#FF5D34",
                                                  icon: "",
                                                  title:
                                                    "Rechazar reprogramación"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    $event.preventDefault()
                                                    return _vm.rechazarReprogramacion(
                                                      items.item
                                                    )
                                                  }
                                                }
                                              },
                                              [_c("v-icon", [_vm._v("close")])],
                                              1
                                            )
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                items.item.tipo == "VC"
                                  ? _c(
                                      "td",
                                      {
                                        attrs: {
                                          id:
                                            items.item.tipo == "P"
                                              ? "celdaP"
                                              : items.item.tipo == "R"
                                              ? "celdaR"
                                              : items.item.tipo == "VC"
                                              ? "celdaVC"
                                              : "celdaFR"
                                        }
                                      },
                                      [
                                        _c(
                                          "v-btn",
                                          {
                                            attrs: {
                                              color: "info",
                                              icon: "",
                                              title: "Ver vacacion"
                                            },
                                            on: {
                                              click: function($event) {
                                                $event.preventDefault()
                                                return _vm.verPermiso(
                                                  items.item
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _c("v-icon", [
                                              _vm._v("remove_red_eye")
                                            ])
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        items.item.id_estado == 6
                                          ? _c(
                                              "v-btn",
                                              {
                                                attrs: {
                                                  color: "success",
                                                  icon: "",
                                                  title: "Aprobar permiso"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    $event.preventDefault()
                                                    return _vm.aprobarPermiso(
                                                      items.item
                                                    )
                                                  }
                                                }
                                              },
                                              [_c("v-icon", [_vm._v("done")])],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        items.item.id_estado == 6
                                          ? _c(
                                              "v-btn",
                                              {
                                                attrs: {
                                                  color: "#E61C5B",
                                                  dark: "",
                                                  icon: "",
                                                  title: "Rechazar permiso"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    $event.preventDefault()
                                                    return _vm.rechazarPermiso(
                                                      items.item
                                                    )
                                                  }
                                                }
                                              },
                                              [_c("v-icon", [_vm._v("close")])],
                                              1
                                            )
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        3015525855
                      )
                    },
                    [
                      _c(
                        "template",
                        { slot: "buttons" },
                        [
                          _c(
                            "v-tooltip",
                            { attrs: { bottom: "" } },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    slot: "activator",
                                    color: "warning",
                                    dark: ""
                                  },
                                  nativeOn: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      return _vm.verReporte({}, 7)
                                    }
                                  },
                                  slot: "activator"
                                },
                                [
                                  _c("v-icon", { attrs: { dark: "" } }, [
                                    _vm._v("picture_as_pdf")
                                  ])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("span", [_vm._v("Ver reporte")])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    2
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4d7adb6c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d7adb6c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/vacacion_uso/VacacionUsoJefeInmediato.vue
// module id = null
// module chunks = 